import { render, staticRenderFns } from "./MS_popup.vue?vue&type=template&id=6dfcf3d1&scoped=true"
import script from "./MS_popup.vue?vue&type=script&lang=js"
export * from "./MS_popup.vue?vue&type=script&lang=js"
import style0 from "./MS_popup.vue?vue&type=style&index=0&id=6dfcf3d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfcf3d1",
  null
  
)

export default component.exports